"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const splToken = __importStar(require("spl-token-latest"));
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const programIds_1 = require("../constants/programIds");
const main_1 = require("../main");
const cmp = __importStar(require("@solana/spl-account-compression"));
const mpl = __importStar(require("@metaplex-foundation/mpl-token-metadata"));
const itemv2_1 = require("../state/itemv2");
class Instruction extends sol_kit_1.Instruction {
    constructor(args) {
        super(args);
    }
    async createItemClass(args) {
        const signers = [];
        const ixns = [];
        // create authority mint account and mint some to the creator
        const authorityMint = anchor_1.web3.Keypair.generate();
        signers.push(authorityMint);
        // derive item class pda
        const itemClass = itemv2_1.getItemClassPda(authorityMint.publicKey);
        const createAuthorityMintAccountIx = await anchor_1.web3.SystemProgram.createAccount({
            programId: splToken.TOKEN_PROGRAM_ID,
            space: splToken.MintLayout.span,
            fromPubkey: this.program.client.provider.publicKey,
            newAccountPubkey: authorityMint.publicKey,
            lamports: await this.program.client.provider.connection.getMinimumBalanceForRentExemption(splToken.MintLayout.span),
        });
        ixns.push(createAuthorityMintAccountIx);
        // make it an SFT
        const initAuthorityMintIx = splToken.createInitializeMintInstruction(authorityMint.publicKey, 0, this.program.client.provider.publicKey, this.program.client.provider.publicKey);
        ixns.push(initAuthorityMintIx);
        const destinationAta = splToken.getAssociatedTokenAddressSync(authorityMint.publicKey, this.program.client.provider.publicKey);
        const createAuthorityMintDestinationIx = splToken.createAssociatedTokenAccountIdempotentInstruction(this.program.client.provider.publicKey, destinationAta, this.program.client.provider.publicKey, authorityMint.publicKey);
        ixns.push(createAuthorityMintDestinationIx);
        const [metadata, _metadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            authorityMint.publicKey.toBuffer(),
        ], mpl.PROGRAM_ID);
        const createAuthorityMintMetadataIx = mpl.createCreateMetadataAccountV3Instruction({
            metadata: metadata,
            mint: authorityMint.publicKey,
            mintAuthority: this.program.client.provider.publicKey,
            payer: this.program.client.provider.publicKey,
            updateAuthority: this.program.client.provider.publicKey,
        }, {
            createMetadataAccountArgsV3: {
                data: {
                    name: "ItemsV2 Auth Token",
                    symbol: "AUTH",
                    uri: "https://foo.com/bar.json",
                    sellerFeeBasisPoints: 0,
                    creators: null,
                    collection: null,
                    uses: null,
                },
                collectionDetails: null,
                isMutable: true,
            },
        });
        ixns.push(createAuthorityMintMetadataIx);
        // mint 3 tokens to the deployer/authority
        const mintAuthorityTokensIx = splToken.createMintToInstruction(authorityMint.publicKey, destinationAta, this.program.client.provider.publicKey, 3);
        ixns.push(mintAuthorityTokensIx);
        // transfer minting authority to item class
        const transferAuthorityToItemClassIx = splToken.createSetAuthorityInstruction(authorityMint.publicKey, this.program.client.provider.publicKey, splToken.AuthorityType.MintTokens, itemClass);
        ixns.push(transferAuthorityToItemClassIx);
        let merkleTree = null;
        let logWrapper = null;
        let accountCompression = null;
        switch (args.mode.kind) {
            case "MerkleTree": {
                // create merkle tree account
                const tree = anchor_1.web3.Keypair.generate();
                // hardcoded to match the contract code
                const maxDepth = 16;
                const maxBufferSize = 64;
                const treeSpace = cmp.getConcurrentMerkleTreeAccountSize(maxDepth, maxBufferSize);
                const treeLamports = await this.program.client.provider.connection.getMinimumBalanceForRentExemption(treeSpace);
                const createAccountIx = await anchor_1.web3.SystemProgram.createAccount({
                    fromPubkey: this.program.client.provider.publicKey,
                    newAccountPubkey: tree.publicKey,
                    lamports: treeLamports,
                    space: treeSpace,
                    programId: cmp.PROGRAM_ID,
                });
                ixns.push(createAccountIx);
                merkleTree = tree.publicKey;
                logWrapper = cmp.SPL_NOOP_PROGRAM_ID;
                accountCompression = cmp.PROGRAM_ID;
                signers.push(tree);
                break;
            }
            case "Collection":
                // client side check that collectionMint is truly a mint account
                await splToken.getMint(this.program.client.provider.connection, args.mode.collectionMint);
                break;
            case "Pack":
                break;
            case "PresetOnly":
                break;
        }
        const ixArgs = {
            itemClassName: args.itemClassName,
            mode: itemv2_1.formatItemClassModeSelection(args.mode),
        };
        const createItemClassIx = await this.program.client.methods
            .createItemClass(ixArgs)
            .accounts({
            tree: merkleTree,
            itemClass: itemClass,
            itemClassAuthorityMint: authorityMint.publicKey,
            itemClassAuthorityMintAta: destinationAta,
            authority: this.program.client.provider.publicKey,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            accountCompression: accountCompression,
            logWrapper: logWrapper,
        })
            .instruction();
        ixns.push(createItemClassIx);
        return [itemClass, signers, ixns];
    }
    async addItemsToItemClass(accounts) {
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass);
        const mode = itemv2_1.parseItemClassMode(itemClassData);
        if (mode.kind !== "MerkleTree") {
            throw new Error(`invalid item class mode for addItemsToItemClass`);
        }
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, this.program.client.provider.publicKey);
        const ixns = [];
        for (const itemMint of accounts.itemMints) {
            const ix = await this.program.client.methods
                .addItemToItemClass()
                .accounts({
                itemMint: itemMint,
                itemClass: accounts.itemClass,
                itemClassAuthorityMint: authorityMint,
                itemClassAuthorityMintAta: authorityMintAta,
                itemClassMerkleTree: mode.tree,
                authority: this.program.client.provider.publicKey,
                logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
                accountCompression: cmp.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
            })
                .instruction();
            ixns.push(ix);
        }
        return ixns;
    }
    async createPack(accounts, args) {
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass, "processed");
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, this.program.client.provider.publicKey);
        const mode = itemv2_1.parseItemClassMode(itemClassData);
        if (mode.kind !== "Pack") {
            throw new Error(`Invalid Item Class mode: ${mode} for pack creation`);
        }
        const packAccount = itemv2_1.getPackPda(accounts.itemClass, mode.index);
        const ix = await this.program.client.methods
            .createPack(args)
            .accounts({
            pack: packAccount,
            itemClass: accounts.itemClass,
            itemClassAuthorityMint: authorityMint,
            itemClassAuthorityMintAta: authorityMintAta,
            authority: this.program.client.provider.publicKey,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return [ix, packAccount];
    }
    async revertBuild(accounts) {
        const build = itemv2_1.getBuildPda(accounts.itemClass, accounts.builder);
        const ix = await this.program.client.methods
            .revertBuild()
            .accounts({
            build: build,
            builder: accounts.builder,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async buildSimpleBuild(accounts, args) {
        const recipePda = itemv2_1.getRecipePda(args.recipe.itemClass, args.recipe.recipeIndex);
        const itemSource = splToken.getAssociatedTokenAddressSync(accounts.itemMint, args.recipe.itemClass, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(accounts.itemMint, accounts.builder);
        const paymentTreasury = args.recipe.payment.treasury;
        const ix = await this.program.client.methods
            .buildSimpleBuild(args)
            .accounts({
            recipe: recipePda,
            itemClass: args.recipe.itemClass,
            itemMint: accounts.itemMint,
            itemSource: itemSource,
            itemDestination: itemDestination,
            paymentTreasury: paymentTreasury,
            builder: accounts.builder,
            recipeOwner: accounts.recipeOwner,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return [ix];
    }
    async startBuild(accounts, args) {
        const recipe = itemv2_1.getRecipePda(accounts.itemClass, args.recipeIndex);
        const build = itemv2_1.getBuildPda(accounts.itemClass, accounts.builder);
        let recipeDataRaw = null;
        let recipeV2 = true;
        try {
            recipeDataRaw = await this.program.client.account.recipeV2.fetch(recipe);
        }
        catch (e) {
            console.log(`Error fetching v2 recipe ${e}. Falling back to v1`);
            recipeV2 = false;
            recipeDataRaw = await this.program.client.account.recipe.fetch(recipe);
        }
        // if build permit is required create the pda
        let buildPermit = null;
        if (recipeDataRaw.buildPermitRequired) {
            buildPermit = itemv2_1.getBuildPermitPda(accounts.builder, accounts.itemClass);
        }
        const ix = await this.program.client.methods
            .startBuild(args)
            .accounts({
            build: build,
            recipe: !recipeV2 ? recipe : null,
            recipeV2: recipeV2 ? recipe : null,
            itemClass: accounts.itemClass,
            buildPermit: buildPermit,
            builder: accounts.builder,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async addIngredient(accounts, args) {
        const item = itemv2_1.getItemPda(accounts.ingredientMint);
        const build = itemv2_1.getBuildPda(accounts.itemClass, accounts.builder);
        // detect what type of token we are adding
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.ingredientMint);
        const buildDataRaw = await this.program.client.account.build.fetch(build);
        // get deterministic ingredient pda if applicable
        let deterministicIngredient = null;
        for (const rawIngredient of buildDataRaw.ingredients) {
            const match = rawIngredient.mints.some((mintData) => new anchor_1.web3.PublicKey(mintData.mint).equals(accounts.ingredientMint));
            if (match && Boolean(rawIngredient.isDeterministic)) {
                deterministicIngredient = itemv2_1.getDeterministicIngredientPda(accounts.itemClass, accounts.ingredientMint);
            }
        }
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIxns = await this.addIngredientPnft(accounts, build, item, deterministicIngredient);
            ixns.push(...pNftIxns);
        }
        else {
            const ix = await this.addIngredientSpl(accounts, build, item, deterministicIngredient, args);
            ixns.push(ix);
        }
        return ixns;
    }
    async addIngredientSpl(accounts, build, item, deterministicIngredient, args) {
        const ingredientSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, accounts.builder);
        const ingredientDestination = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, build, true);
        const ix = await this.program.client.methods
            .addIngredientSpl(args)
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientSource: ingredientSource,
            ingredientDestination: ingredientDestination,
            deterministicIngredient: deterministicIngredient,
            build: build,
            item: item,
            builder: accounts.builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async addIngredientPnft(accounts, build, item, deterministicIngredient) {
        const [ingredientMetadata, _ingredientMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const ingredientMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, ingredientMetadata, "confirmed");
        const [ingredientME, _ingredientMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const ingredientSource = splToken.getAssociatedTokenAddressSync(accounts.ingredientMint, accounts.builder);
        const ingredientDestination = splToken.getAssociatedTokenAddressSync(accounts.ingredientMint, build, true);
        const [ingredientSourceTokenRecord, _ingredientSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            ingredientSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [ingredientDestinationTokenRecord, _ingredientDestinationTokenRecordBump,] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            ingredientDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .addIngredientPnft()
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientMetadata: ingredientMetadata,
            ingredientEdition: ingredientME,
            deterministicIngredient: deterministicIngredient,
            authRules: ingredientMetadataData.programmableConfig.ruleSet,
            ingredientSource: ingredientSource,
            ingredientSourceTokenRecord: ingredientSourceTokenRecord,
            ingredientDestination: ingredientDestination,
            ingredientDestinationTokenRecord: ingredientDestinationTokenRecord,
            build: build,
            item: item,
            payer: accounts.payer,
            builder: accounts.builder,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
            authRulesProgram: main_1.Constants.ProgramIds.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async verifyIngredient(accounts, args) {
        const ingredientItemClassData = await this.program.client.account.itemClass.fetch(accounts.ingredientItemClass);
        let ingredientMintMetadata = null;
        let ingredientItemClassVerifyAccount = null;
        let deterministicIngredient = null;
        let logWrapper = null;
        let accountCompression = null;
        const proofAsRemainingAccounts = [];
        let ixArgs = null;
        const build = itemv2_1.getBuildPda(accounts.itemClass, accounts.builder);
        const buildData = await this.program.client.account.build.fetch(build);
        const mode = itemv2_1.parseItemClassMode(ingredientItemClassData);
        // check if ingredient is deterministic
        const deterministicIngredientPda = itemv2_1.getDeterministicIngredientPda(new anchor_1.web3.PublicKey(buildData.recipe), accounts.ingredientMint);
        const deterministicIngredientData = await this.program.client.account.deterministicIngredient.fetchNullable(deterministicIngredientPda);
        if (deterministicIngredientData !== null) {
            deterministicIngredient = deterministicIngredientPda;
        }
        else {
            switch (mode.kind) {
                case "MerkleTree":
                    logWrapper = cmp.SPL_NOOP_PROGRAM_ID;
                    accountCompression = cmp.PROGRAM_ID;
                    ingredientItemClassVerifyAccount = mode.tree;
                    for (const node of args.proof) {
                        const nodeAccount = {
                            pubkey: new anchor_1.web3.PublicKey(node),
                            isSigner: false,
                            isWritable: false,
                        };
                        proofAsRemainingAccounts.push(nodeAccount);
                    }
                    ixArgs = {
                        root: args.root,
                        leafIndex: args.leafIndex,
                    };
                    break;
                case "Collection": {
                    const [metadata, _metadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
                        Buffer.from("metadata"),
                        mpl.PROGRAM_ID.toBuffer(),
                        accounts.ingredientMint.toBuffer(),
                    ], mpl.PROGRAM_ID);
                    ingredientMintMetadata = metadata;
                    ingredientItemClassVerifyAccount = mode.collectionMint;
                    break;
                }
                case "Pack":
                    throw new Error(`ItemClasses in Pack Mode cannot be Ingredients`);
                case "PresetOnly":
                    throw new Error(`ItemClasses in PresetOnly Mode cannot be Ingredients`);
            }
        }
        const ix = await this.program.client.methods
            .verifyIngredient(ixArgs)
            .accounts({
            item: itemv2_1.getItemPda(accounts.ingredientMint),
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientMintMetadata: ingredientMintMetadata,
            deterministicIngredient: deterministicIngredient,
            ingredientItemClassVerifyAccount: ingredientItemClassVerifyAccount,
            build: build,
            payer: accounts.payer,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            logWrapper: logWrapper,
            accountCompression: accountCompression,
        })
            .remainingAccounts(proofAsRemainingAccounts)
            .instruction();
        return ix;
    }
    async verifyIngredientMerkleTreeTest(accounts, args) {
        const ingredientItemClassData = await this.program.client.account.itemClass.fetch(accounts.ingredientItemClass);
        const mode = itemv2_1.parseItemClassMode(ingredientItemClassData);
        if (mode.kind !== "MerkleTree") {
            throw new Error(`Invalid ItemClass mode: ${mode} for Merkle Tree Verification Test`);
        }
        const proofAsRemainingAccounts = [];
        for (const node of args.proof) {
            const nodeAccount = {
                pubkey: new anchor_1.web3.PublicKey(node),
                isSigner: false,
                isWritable: false,
            };
            proofAsRemainingAccounts.push(nodeAccount);
        }
        const ixArgs = {
            root: Buffer.from(args.root.toString()),
            leafIndex: args.leafIndex,
        };
        const ix = await this.program.client.methods
            .verifyIngredientMerkleTreeTest(ixArgs)
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientItemClassMerkleTree: mode.tree,
            payer: accounts.payer,
            logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
            accountCompression: cmp.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
        })
            .remainingAccounts(proofAsRemainingAccounts)
            .instruction();
        return ix;
    }
    async completeBuild(accounts, args) {
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const itemClass = new anchor_1.web3.PublicKey(buildData.itemClass);
        const itemClassData = await this.program.client.account.itemClass.fetch(itemClass);
        let itemMint = null;
        let itemMintMetadata = null;
        let itemClassVerifyAccount = null;
        let pack = null;
        let logWrapper = null;
        let accountCompression = null;
        const proofAsRemainingAccounts = [];
        const ixArgs = {
            merkleTreeArgs: null,
            packArgs: null,
        };
        const mode = itemv2_1.parseItemClassMode(itemClassData);
        switch (mode.kind) {
            case "MerkleTree":
                logWrapper = cmp.SPL_NOOP_PROGRAM_ID;
                accountCompression = cmp.PROGRAM_ID;
                itemMint = accounts.itemMint;
                itemClassVerifyAccount = mode.tree;
                for (const node of args.merkleTreeArgs.proof) {
                    const nodeAccount = {
                        pubkey: new anchor_1.web3.PublicKey(node),
                        isSigner: false,
                        isWritable: false,
                    };
                    proofAsRemainingAccounts.push(nodeAccount);
                }
                ixArgs.merkleTreeArgs = {
                    root: args.merkleTreeArgs.root,
                    leafIndex: args.merkleTreeArgs.leafIndex,
                };
                break;
            case "Collection": {
                itemMint = accounts.itemMint;
                itemClassVerifyAccount = mode.collectionMint;
                const [metadata, _metadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
                    Buffer.from("metadata"),
                    mpl.PROGRAM_ID.toBuffer(),
                    itemMint.toBuffer(),
                ], mpl.PROGRAM_ID);
                itemMintMetadata = metadata;
                break;
            }
            case "Pack":
                pack = accounts.pack;
                ixArgs.packArgs = {
                    packContents: args.packArgs.packContents,
                };
                break;
            case "PresetOnly":
                break;
        }
        // if build permit is required create the pda
        let buildPermit = null;
        if (buildData.buildPermitInUse) {
            buildPermit = itemv2_1.getBuildPermitPda(new anchor_1.web3.PublicKey(buildData.builder), itemClass);
        }
        const ix = await this.program.client.methods
            .completeBuild(ixArgs)
            .accounts({
            itemMint: itemMint,
            itemMintMetadata: itemMintMetadata,
            itemClass: itemClass,
            itemClassVerifyAccount: itemClassVerifyAccount,
            pack: pack,
            buildPermit: buildPermit,
            build: accounts.build,
            payer: accounts.payer,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            logWrapper: logWrapper,
            accountCompression: accountCompression,
        })
            .remainingAccounts(proofAsRemainingAccounts)
            .instruction();
        return ix;
    }
    async receiveItem(accounts) {
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const ixnGroups = [];
        for (const item of buildData.output.items) {
            // if received already, dont send again
            if (item.received === true) {
                continue;
            }
            const itemMint = new anchor_1.web3.PublicKey(item.mint);
            // detect what type of token we are adding
            const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, new anchor_1.web3.PublicKey(item.mint));
            if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
                const pNftIxns = await this.receiveItemPNft(accounts.build, accounts.payer, itemMint);
                ixnGroups.push(pNftIxns);
            }
            else {
                const splIx = await this.receiveItemSpl(accounts.build, accounts.payer, itemMint);
                ixnGroups.push([splIx]);
            }
        }
        return ixnGroups;
    }
    async receiveItemPNft(build, payer, itemMint) {
        const buildData = await this.program.client.account.build.fetch(build);
        const itemClass = new anchor_1.web3.PublicKey(buildData.itemClass);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata, "confirmed");
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const itemSource = splToken.getAssociatedTokenAddressSync(itemMint, itemClass, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(itemMint, builder);
        const [itemSourceTokenRecord, _itemSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
            Buffer.from("token_record"),
            itemSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemDestinationTokenRecord, _itemDestinationTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
            Buffer.from("token_record"),
            itemDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .receiveItemPnft()
            .accounts({
            itemMint: itemMint,
            itemMetadata: itemMetadata,
            itemEdition: itemME,
            authRules: itemMetadataData.programmableConfig.ruleSet,
            itemSource: itemSource,
            itemSourceTokenRecord: itemSourceTokenRecord,
            itemDestination: itemDestination,
            itemDestinationTokenRecord: itemDestinationTokenRecord,
            itemClass: itemClass,
            build: build,
            builder: builder,
            payer: payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
            authRulesProgram: programIds_1.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async receiveItemSpl(build, payer, itemMint) {
        const buildData = await this.program.client.account.build.fetch(build);
        const itemClass = new anchor_1.web3.PublicKey(buildData.itemClass);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const itemSource = splToken.getAssociatedTokenAddressSync(itemMint, itemClass, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(itemMint, builder);
        return await this.program.client.methods
            .receiveItemSpl()
            .accounts({
            itemMint: itemMint,
            itemSource: itemSource,
            itemDestination: itemDestination,
            itemClass: itemClass,
            build: build,
            builder: builder,
            payer: payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
    }
    async applyBuildEffect(accounts) {
        const item = itemv2_1.getItemPda(accounts.ingredientMint);
        const ix = await this.program.client.methods
            .applyBuildEffect()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            build: accounts.build,
            payer: accounts.payer,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async returnIngredient(accounts) {
        const item = itemv2_1.getItemPda(accounts.ingredientMint);
        // detect what type of token we are adding
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.ingredientMint);
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIxns = await this.returnIngredientPNft(accounts, accounts.build, item);
            ixns.push(...pNftIxns);
        }
        else {
            const ix = await this.returnIngredientSpl(accounts, accounts.build, item);
            ixns.push(ix);
        }
        return ixns;
    }
    async returnIngredientPNft(accounts, build, item) {
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata, "confirmed");
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const buildData = await this.program.client.account.build.fetch(build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const itemSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, build, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, builder);
        const [itemSourceTokenRecord, _itemSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            itemSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemDestinationTokenRecord, _itemDestinationTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            itemDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .returnIngredientPnft()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemMetadata: itemMetadata,
            itemEdition: itemME,
            authRules: itemMetadataData.programmableConfig.ruleSet,
            itemSource: itemSource,
            itemSourceTokenRecord: itemSourceTokenRecord,
            itemDestination: itemDestination,
            itemDestinationTokenRecord: itemDestinationTokenRecord,
            build: build,
            builder: builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
            authRulesProgram: main_1.Constants.ProgramIds.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async returnIngredientSpl(accounts, build, item) {
        const buildData = await this.program.client.account.build.fetch(build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const itemSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, build, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, builder);
        const ix = await this.program.client.methods
            .returnIngredientSpl()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemSource: itemSource,
            itemDestination: itemDestination,
            build: build,
            builder: builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async destroyIngredient(accounts) {
        const item = itemv2_1.getItemPda(accounts.ingredientMint);
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.ingredientMint);
        const itemSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, accounts.build, true);
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIx = await this.destroyIngredientPnft(accounts, item, itemSource);
            ixns.push(pNftIx);
        }
        else {
            const ix = await this.destroyIngredientSpl(accounts, item, builder, itemSource);
            ixns.push(ix);
        }
        return ixns;
    }
    async destroyIngredientPnft(accounts, item, itemAta) {
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const [itemTokenRecord, _itemTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            itemAta.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata);
        const [collectionMetadata, _collectionMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMetadataData.collection.key.toBuffer(),
        ], mpl.PROGRAM_ID);
        const ix = await this.program.client.methods
            .destroyIngredientPnft()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemMetadata: itemMetadata,
            collectionMetadata: collectionMetadata,
            itemEdition: itemME,
            itemAta: itemAta,
            itemTokenRecord: itemTokenRecord,
            build: accounts.build,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async destroyIngredientSpl(accounts, item, builder, itemSource) {
        const ix = await this.program.client.methods
            .destroyIngredientSpl()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemSource: itemSource,
            build: accounts.build,
            builder: builder,
            payer: accounts.payer,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async createRecipe(accounts, args) {
        const ingredients = [];
        for (const ingredientArg of args.args.ingredientArgs) {
            let degradationBuildEffect;
            if (ingredientArg.buildEffect.degradation) {
                degradationBuildEffect = {
                    on: { rate: ingredientArg.buildEffect.degradation.rate },
                };
            }
            else {
                degradationBuildEffect = { off: {} };
            }
            let cooldownBuildEffect;
            if (ingredientArg.buildEffect.cooldown) {
                cooldownBuildEffect = {
                    on: { seconds: ingredientArg.buildEffect.cooldown.seconds },
                };
            }
            else {
                cooldownBuildEffect = { off: {} };
            }
            const ingredient = {
                itemClass: ingredientArg.itemClass,
                requiredAmount: ingredientArg.requiredAmount,
                buildEffect: {
                    degradation: degradationBuildEffect,
                    cooldown: cooldownBuildEffect,
                },
                isDeterministic: ingredientArg.isDeterministic,
            };
            ingredients.push(ingredient);
        }
        const ixArgs = {
            recipeType: itemv2_1.formatRecipeType(args.args.recipeType),
            buildEnabled: args.args.buildEnabled,
            ingredients: ingredients,
            payment: args.args.payment,
            buildPermitRequired: args.args.buildPermitRequired,
            selectableOutputs: args.args.selectableOutputs,
        };
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass);
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, this.program.client.provider.publicKey);
        let recipeIndex;
        if (itemClassData.recipeIndex === null) {
            recipeIndex = new anchor_1.BN(0);
        }
        else {
            recipeIndex = new anchor_1.BN(itemClassData.recipeIndex).add(new anchor_1.BN(1));
        }
        // get new recipe pda based off item class recipe index
        const newRecipe = itemv2_1.getRecipePda(accounts.itemClass, recipeIndex);
        const ix = await this.program.client.methods
            .createRecipe(ixArgs)
            .accounts({
            recipe: newRecipe,
            itemClass: accounts.itemClass,
            itemClassAuthorityMint: authorityMint,
            itemClassAuthorityMintAta: authorityMintAta,
            authority: this.program.client.provider.publicKey,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async closeBuild(accounts) {
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const ix = await this.program.client.methods
            .closeBuild()
            .accounts({
            build: accounts.build,
            builder: builder,
            payer: accounts.payer,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async escrowPayment(accounts) {
        const buildPaymentEscrow = itemv2_1.getBuildPaymentEscrowPda(accounts.build);
        const ix = await this.program.client.methods
            .escrowPayment()
            .accounts({
            build: accounts.build,
            builder: accounts.builder,
            buildPaymentEscrow: buildPaymentEscrow,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async transferPayment(accounts) {
        const buildPaymentEscrow = itemv2_1.getBuildPaymentEscrowPda(accounts.build);
        const ix = await this.program.client.methods
            .transferPayment()
            .accounts({
            build: accounts.build,
            buildPaymentEscrow: buildPaymentEscrow,
            destination: accounts.destination,
            payer: accounts.payer,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async createBuildPermit(accounts, args) {
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass);
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, this.program.client.provider.publicKey);
        const buildPermit = itemv2_1.getBuildPermitPda(accounts.builder, accounts.itemClass);
        const ix = await this.program.client.methods
            .createBuildPermit(args)
            .accounts({
            buildPermit: buildPermit,
            builder: accounts.builder,
            itemClass: accounts.itemClass,
            itemClassAuthorityMint: authorityMint,
            itemClassAuthorityMintAta: authorityMintAta,
            authority: this.program.client.provider.publicKey,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async createDeterministicIngredient(accounts, args) {
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass);
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, this.program.client.provider.publicKey);
        const deterministicIngredient = itemv2_1.getDeterministicIngredientPda(accounts.itemClass, accounts.ingredientMint);
        const ix = await this.program.client.methods
            .createDeterministicIngredient(args)
            .accounts({
            itemClass: accounts.itemClass,
            ingredientMint: accounts.ingredientMint,
            deterministicIngredient: deterministicIngredient,
            itemClassAuthorityMint: authorityMint,
            itemClassAuthorityMintAta: authorityMintAta,
            authority: this.program.client.provider.publicKey,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async releaseFromEscrow(accounts, args) {
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.itemMint);
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIx = await this.releaseFromEscrowPNft(accounts);
            ixns.push(...pNftIx);
        }
        else {
            const ix = await this.releaseFromEscrowSpl(accounts, args);
            ixns.push(ix);
        }
        return ixns;
    }
    async releaseFromEscrowPNft(accounts) {
        const itemSource = splToken.getAssociatedTokenAddressSync(accounts.itemMint, accounts.itemClass, true);
        const itemDestination = splToken.getAssociatedTokenAddressSync(accounts.itemMint, accounts.destinationAuthority, true);
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.itemMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.itemMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const [itemSourceTokenRecord, _itemSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.itemMint.toBuffer(),
            Buffer.from("token_record"),
            itemSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemDestinationTokenRecord, _itemDestinationTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.itemMint.toBuffer(),
            Buffer.from("token_record"),
            itemDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata);
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass);
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, accounts.itemClassauthority);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .releaseFromEscrowPnft()
            .accounts({
            itemMint: accounts.itemMint,
            itemMetadata: itemMetadata,
            itemEdition: itemME,
            authRules: itemMetadataData.programmableConfig.ruleSet,
            itemSource: itemSource,
            itemSourceTokenRecord: itemSourceTokenRecord,
            itemDestination: itemDestination,
            itemDestinationTokenRecord: itemDestinationTokenRecord,
            destinationAuthority: accounts.destinationAuthority,
            itemClass: accounts.itemClass,
            itemClassAuthorityMint: authorityMint,
            itemClassAuthorityMintAta: authorityMintAta,
            authority: accounts.itemClassauthority,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: splToken.TOKEN_PROGRAM_ID,
            associatedTokenProgram: splToken.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: mpl.PROGRAM_ID,
            authRulesProgram: programIds_1.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async releaseFromEscrowSpl(accounts, args) {
        const itemSource = splToken.getAssociatedTokenAddressSync(accounts.itemMint, accounts.itemClass, true);
        const itemDestination = splToken.getAssociatedTokenAddressSync(accounts.itemMint, accounts.destinationAuthority, true);
        const itemClassData = await this.program.client.account.itemClass.fetch(accounts.itemClass);
        const authorityMint = new anchor_1.web3.PublicKey(itemClassData.authorityMint);
        const authorityMintAta = splToken.getAssociatedTokenAddressSync(authorityMint, accounts.itemClassauthority);
        const ix = await this.program.client.methods
            .releaseFromEscrowSpl(args)
            .accounts({
            itemMint: accounts.itemMint,
            itemSource: itemSource,
            itemDestination: itemDestination,
            destinationAuthority: accounts.destinationAuthority,
            itemClass: accounts.itemClass,
            itemClassAuthorityMint: authorityMint,
            itemClassAuthorityMintAta: authorityMintAta,
            authority: accounts.itemClassauthority,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: splToken.TOKEN_PROGRAM_ID,
            associatedTokenProgram: splToken.ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async migrateBuildAccount(build, recipe) {
        const ixns = [];
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 1000000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        ixns.push(increaseCUIx, addPriorityFeeIx);
        const ix = await this.program.client.methods
            .migrateBuildAccount()
            .accounts({
            build: build,
            recipe: recipe,
            payer: this.program.client.provider.publicKey,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        ixns.push(ix);
        return ixns;
    }
    async migrateItemClassAccount(itemClass) {
        const ix = await this.program.client.methods
            .migrateItemClassAccount()
            .accounts({
            itemClass: itemClass,
            payer: this.program.client.provider.publicKey,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
}
exports.Instruction = Instruction;
